import cx from "classnames";
import * as React from "react";

import MyRepeatLogo from "assets/images/RepeatMD_myRepeat.svg?url";

export interface PlatformLogoProps {
  logoUrl?: string | null;
  platformName?: string | null;
  className?: string;
  locationLogoUrl?: string | null;
  locationName?: string | null;
  compact?: boolean;
  showPlatformLogo?: boolean;
}

export const PlatformLogo: React.FC<PlatformLogoProps> = ({
  className,
  logoUrl,
  platformName,
  locationLogoUrl,
  locationName,
  compact = false,
  showPlatformLogo = true,
}) => {
  if (!showPlatformLogo && locationLogoUrl) {
    return (
      <img
        className={cx(
          "object-contain",
          compact ? "h-8 w-auto max-w-32 max-[360px]:max-w-24" : "max-h-48 w-1/3 max-w-48",
          className,
        )}
        src={locationLogoUrl}
        alt={locationName ?? ""}
      />
    );
  }
  if (locationLogoUrl || compact) {
    return (
      <div
        className={cx(
          "flex max-w-full items-center justify-center gap-3",
          compact && "max-[360px]:gap-2",
          className,
        )}
      >
        <img
          className={cx(
            "object-contain",
            compact
              ? "h-8 w-auto max-w-32 shrink-0 max-[360px]:max-w-24"
              : "h-16 min-w-0 max-w-[45%]",
          )}
          src={logoUrl ?? MyRepeatLogo}
          alt={logoUrl ? (platformName ?? "RepeatMD") : "RepeatMD"}
        />
        {locationLogoUrl ? (
          <>
            <span
              aria-hidden="true"
              className={cx("w-px shrink-0 bg-outline-grey", compact ? "h-7" : "h-12")}
            />
            <img
              className={cx(
                "object-contain",
                compact
                  ? "h-8 w-auto max-w-12 shrink-0 max-[360px]:max-w-7"
                  : "h-16 min-w-0 max-w-[45%]",
              )}
              src={locationLogoUrl}
              alt={locationName ?? ""}
            />
          </>
        ) : null}
      </div>
    );
  }

  return (
    <img
      className={cx("max-h-48 w-1/3 max-w-48 object-contain", className)}
      src={logoUrl ?? MyRepeatLogo}
      alt={logoUrl ? (platformName ?? "RepeatMD") : "RepeatMD"}
    />
  );
};
